import React, { Component } from 'react';
import { Box, Button, Drawer, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/FOReports/reports.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from "../../../../Components/Common Components/CommonComponents";
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { splitDate, AmountFormat, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import Loader from '../../../../Components/Loader';
import { CurrencySymbol } from '../../../../Utility/Constants';

class IssuedDrugReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            IssuedDrugList: [],
            DrugName: "",
            total_bill_amount: 0,
            total_concession: 0,
            module: "",
            uhid: "",
            printLoading: false,
            disableBtn: false,
        }
    }

    componentDidMount() {
        this.getIssuedDrugList()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }
    handleCheckBox = (e, data) => {
        let states = this.state
        data["isChecked"] = e.target.checked
        this.setState({ states })
    }

    getIssuedDrugList = () => {
        try {
            let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
            this.LoaderFunction(true);
            const baseUrl = Serviceurls.ISSUED_DRUG_REPORT;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&drug_name=${this.state.DrugName}&module_type=${this.state.module}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.LoaderFunction(false);
                        let list = response.data?.data || [];
                        list = list.map((item, index) => ({
                            ...item,
                            sno: index + 1,
                        }));
                        this.setState({ IssuedDrugList: list });
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.LoaderFunction(false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    printReports = () => {
        try {
            let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))

            const baseUrl = Serviceurls.ISSUED_DRUG_REPORT;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&bill_no=${this.state.DrugName}&module=${this.state.module}&uhid=${this.state.uhid ? this.state.uhid : ""}&pharmacy_id=${LoggedUserData.pharmacy_id ? LoggedUserData.pharmacy_id : ""}&clinic_id=${LoggedUserData.clinic_id ? LoggedUserData.clinic_id : ""}&export_type=pdf`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                        this.setState({ disableBtn: false, printLoading: false })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.setState({ disableBtn: false, printLoading: false })
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({ disableBtn: false, printLoading: false })
        }
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button emed_tid={'filter_btn'} onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle' overflow={'auto'}>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            emed_tid={"FilterDate_TestID01"}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 35, emed_tid: 'brand_name' }}
                            size='small'
                            label={t("Brand Name")}
                            value={this.state.DrugName}
                            autoComplete='off'
                            emed_tid={"brand_name"}
                            onChange={(e) => {
                                this.setState({ DrugName: e.target.value })
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown' component={'div'}>
                        <FormControl size='small' sx={{ width: '20vw', margin: '0.5vw' }}>
                            <InputLabel>Select Module</InputLabel>
                            <Select
                                label='Select Module'
                                value={this.state.module}
                                onChange={(e) => {
                                    let value = e.target.value
                                    this.setState({
                                        module: value
                                    })
                                }}
                            >
                                <MenuItem emed_tid={"both_module"} value={""}>{"All"}</MenuItem>
                                <MenuItem emed_tid={"op_module"} value={"OP"}>{"OP"}</MenuItem>
                                <MenuItem emed_tid={"ip_module"} value={"IP"}>{"IP"}</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small" emed_tid={"IssuedDrugTestID01"}
                        onClick={() => {
                            if (localGetItem("multiLaboratory") === "true") {
                                this.state.LabData?.forEach((item) => (item["isChecked"] = true))
                            }
                            this.setState({
                                DrugName: "",
                                module: "",
                                uhid: "",
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            }, () => this.getIssuedDrugList())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" emed_tid={"Search_TestID01"}
                        onClick={() => {
                            this.getIssuedDrugList()
                            this.setState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn"  >{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    render() {
        const { t } = this.props
        const columns = [
            {
                field: "patient_name", headerName: t("Patient Details"), flex: 0.16, density: 'compact',
                renderCell: ({ row }) => (<CommonPatientDetails data={row} disablePhoto={true} />)
            },
            {
                field: "module_number", headerName: t("OP/IP No"), flex: 0.17, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.module_number?.length > 25 ?
                    <Tooltip placement='top' title={row?.module_number} arrow><div>{row?.module_number.slice(0, 23) + "..."}</div></Tooltip>
                    : row?.module_number ? row?.module_number : "-"}</Box>)
            },
            {
                field: "drug_name", headerName: t("Drug Name"), flex: 0.2, density: 'compact',
                renderCell: ({ row }) => (<div style={{ display: "flex", flexDirection: "Column" }}><Box component={'div'}>{row?.drug_name?.length > 22 ?
                    <Tooltip placement='top' title={row?.drug_name} arrow><div>{row?.drug_name.slice(0, 20) + "..."}</div></Tooltip>
                    : row?.drug_name ? row?.drug_name : "-"}</Box>
                   </div>)
            },
            {
                field: "batch_no", headerName: t("Batch No"), flex: 0.2, density: 'compact',
                renderCell: ({ row }) => (<div style={{ display: "flex", flexDirection: "Column" }}><Box component={'div'}>{row?.batch_no?.length > 22 ?
                    <Tooltip placement='top' title={row?.batch_no} arrow><div>{row?.batch_no.slice(0, 20) + "..."}</div></Tooltip>
                    : row?.batch_no ? row?.batch_no : "-"}</Box>
                   </div>)
            },
            {
                field: "expiry_date", headerName: t("Expiry Date"), flex: 0.1, density: 'compact', align: "center", headerAlign: "center",
                renderCell: ({ row }) => (<Box>{row?.expiry_date ? formatDate(row?.expiry_date) : "-"}</Box>)
            },
            {
                field: "quantity", headerName: t("Quantity"), flex: 0.1, density: 'compact', type: "number",
                renderCell: ({ row }) => (<Box>{row?.quantity ? row?.quantity : "0"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {/* {AmountsCard(t("Total Bill Amount"), this.state.total_bill_amount)}
                    {AmountsCard(t("Total Discount"), this.state.total_concession)} */}

                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Button className='eMed_usrconf_btn' sx={{ ml: "1vw" }} emed_tid={"eMed_action_img_TestID"} onClick={() => { this.setState({ FilterOpen: true }) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                        {/* <Tooltip title={t("Print")} placement='top' arrow>
                            <Button className='eMed_usrconf_btn' emed_tid={"eMed_usrconf_btn_TestID01"} disabled={this.state.disableBtn} onClick={() => { this.printReports() }}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                            </Button>
                        </Tooltip> */}
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.IssuedDrugList}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader || this.state.printLoading} forPrint={this.state.printLoading ? true : false} label={this.state.printLoading ? "Building PDF..." : null} />
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(IssuedDrugReport)